import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class TitleService {
  private readonly title = inject(Title);
  private readonly translateService = inject(TranslateService);

  public setPageTitle(title: string, translate: boolean = true): void {
    const t = translate ? this.translateService.instant(title) : title;
    if (t && t !== title) this.title.setTitle(t);
    else this.translateService.get(title).subscribe(v => this.title.setTitle(v));
  }
}
